import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import Icon from "@mdi/react";
import {
  mdiViewDashboardOutline,
  mdiViewAgendaOutline,
  mdiEmailOutline,
  mdiAccountOutline,
  mdiDotsHorizontal,
  mdiLogout,
  mdiBellOutline,
} from "@mdi/js";
import LOGO from "../../assets/images/logo.png";
import PROFILE from "../../assets/images/lisa.jpg";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { getFileHostUrl } from "../../helpers/functions";

interface Props {
  toggled: boolean;
  handleToggleSidebar: (toggled: boolean) => void;
}

const SideBarNav: React.FC<Props> = ({ toggled, handleToggleSidebar }) => {
  const location = useLocation();
  const { user, isFetchedUser } = useSelector((state: any) => state);
  const history = useHistory();

  const [currentPath, setCurrentPath] = useState<string>("");
  const getPictrue = (pic: any) => {
    console.log("pic", pic);
    const picture = getFileHostUrl(pic);
    // console.log("picture", picture);
    // setPicture(picture);
    return picture;
  };
  const menuItems = [
    {
      name: "OPD",
      to: "/opd",
      icon: mdiViewDashboardOutline,
    },
    {
      name: "CASHIER",
      to: "/cashier",
      icon: mdiViewAgendaOutline,
    },
    {
      name: "USED COURSE",
      to: "/usedcourse",
      icon: mdiViewAgendaOutline,
    },
    {
      name: "QUOTATION",
      to: "/quotation",
      icon: mdiViewAgendaOutline,
    },
    {
      name: "JOB COST",
      to: "/jobcost",
      icon: mdiEmailOutline,
    },
    {
      name: "BOOKING",
      to: "/booking",
      icon: mdiAccountOutline,
    },
    {
      name: "NOTIFICATION",
      to: "/notification",
      icon: mdiBellOutline,
    },
  ];

  const isActive = (linkTo: string) => {
    // menuItem.to === currentPath

    //  abcdefzzz              de
    // /usedcourse/SO-TestB   /usedcourse
    if (currentPath.startsWith(linkTo)) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    let path = location.pathname;
    // console.log("path =>", path);

    if (path.endsWith("/")) {
      path = path.slice(0, path.length - 1);
    }

    // console.log("path after =>", path);

    setCurrentPath(path);
  }, [location.pathname]);

  const profileUrl =
    process.env.NODE_ENV !== "development"
      ? getPictrue(user?.photoURL)
      : "/user.png";

  return (
    <ProSidebar
      toggled={toggled}
      breakPoint="xl"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div className="logo">
          <img src={LOGO} alt="Dermaster" />
        </div>
      </SidebarHeader>

      <SidebarContent>
        <div className="sidebar-profile1">
          <div className="img-profile">
            <img src={profileUrl} />
          </div>
          <div
            className="info"
            onClick={() =>
              history.push(`/setting/personnel/${user?._id}/personneldetailNew`)
            }
          >
            <div className="info-name">{`${user.displayName}`}</div>
            <div className="info-email">{`${user.email}`}</div>
          </div>
        </div>
        <Menu>
          {menuItems.map((menuItem, index) => (
            <MenuItem
              className={`menu-title ${isActive(menuItem.to) ? "active" : ""}`}
              icon={
                <Icon
                  path={menuItem.icon}
                  size="20"
                  color={isActive(menuItem.to) ? "#5baea9" : "#AEAEAE"}
                />
              }
              key="_id"
            >
              {menuItem.name}
              <Link to={menuItem.to} />
            </MenuItem>
          ))}
        </Menu>
      </SidebarContent>

      <SidebarFooter>
        <Menu>
          <MenuItem
            className="menu-title"
            icon={<Icon path={mdiDotsHorizontal} size="20" color="#AEAEAE" />}
          >
            Setting
            <Link to="/setting" />
          </MenuItem>
          <MenuItem
            className="menu-title"
            icon={<Icon path={mdiLogout} size="20" color="#AEAEAE" />}
          >
            Logout
            <Link to="/logout" />
          </MenuItem>
        </Menu>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default SideBarNav;
